module.exports = __webpack_public_path__ + "img/tu04.8861ff4b.jpg";